import React from "react";
import Link from "next/link";

import "./style.scss";

export interface Props {
    title: string;
    url: string;
    className?: string;
    newTab?: boolean;
}

export const LinkWithArrowRight = ({ title, url, className, newTab }: Props) => {
    const classNames = ["linkWithArrowRight"];

    if (className) {
        classNames.push(className);
    } else {
        classNames.push("black");
    }

    if (newTab) {
        return (
            <a className={classNames.join(" ")} href={url} target="_blank" rel="noopener noreferrer nofollow">
                {title}
            </a>
        );
    }

    return (
        <Link href={url}>
            <a className={classNames.join(" ")}>{title}</a>
        </Link>
    );
};
